export default {
  SET_SETTINGS(state, data) {
    state.settings = data;
  },
};
